import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { User } from '../../../interfaces/auth/auth.interfaces';

@Component({
  selector: 'app-header-admin',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  standalone: false,
})
export class HeaderAdminComponent implements OnInit {
  user: User | null = null;

  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    const user = localStorage.getItem('USER');
    if (user) {
      const userObj = JSON.parse(user);
      this.user = userObj;
    }
  }

  toggleSidebar(): void {
    console.log('Toggle sidebar');
  }
  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
        localStorage.removeItem('token');
      },
    });
  }
}
